import { getSearchParams } from './url-handler'
import { getQS, setQS } from './storage-provider'
import { Istate, IComponentStatus } from '../types'

const state: Istate = {
  queryString: {},
  selectedPayment: {},
  componentStatus: {
    component: 'PaymentSelectList',
    type: '',
  },
  paymentChannelInfo: {},
  storedCards: [],
  orderInfo: {},
}
export const types = {
  GET_QUERY_STRING: 'GET_QUERY_STRING',
  QUERY_STRING: 'QUERY_STRING',
  SELECTED_PAYMENT: 'SELECTED_PAYMENT',
  SET_SELECTED_PAYMENT: 'SET_SELECTED_PAYMENT',
  SET_COMPONENT_STATUS: 'SET_COMPONENT_STATUS',
  COMPONENT_STATUS: 'COMPONENT_STATUS',
  SET_PAYMENT_CHANNEL_INFO: 'SET_PAYMENT_CHANNEL_INFO',
  PAYMENT_CHANNEL_INFO: 'PAYMENT_CHANNEL_INFO',
  SET_STORED_CARDS: 'SET_STORED_CARDS',
  STORED_CARDS: 'STORED_CARDS',
  SET_ORDER_INFO: 'SET_ORDER_INFO',
  ORDER_INFO: 'ORDER_INFO',
}

const getters = {
  [types.QUERY_STRING](state: Istate) {
    return state.queryString
  },
  [types.SELECTED_PAYMENT](state: Istate) {
    return state.selectedPayment
  },
  [types.COMPONENT_STATUS](state: Istate) {
    return state.componentStatus
  },
  [types.PAYMENT_CHANNEL_INFO](state: Istate) {
    return state.paymentChannelInfo
  },
  [types.STORED_CARDS](state: Istate) {
    return state.storedCards
  },
  [types.ORDER_INFO](state: Istate) {
    return state.orderInfo
  },
}

const mutations = {
  [types.GET_QUERY_STRING](state: Istate) {
    setQS(getSearchParams())
    state.queryString = getQS()
  },
  [types.SET_SELECTED_PAYMENT](state: Istate, payload: any) {
    state.selectedPayment = payload
  },
  [types.SET_COMPONENT_STATUS](state: Istate, payload: IComponentStatus) {
    state.componentStatus = payload
  },
  [types.SET_PAYMENT_CHANNEL_INFO](state: Istate, payload: any) {
    state.paymentChannelInfo = payload
  },
  [types.SET_STORED_CARDS]: (state: Istate, payload: any) => {
    state.storedCards = payload
  },
  [types.SET_ORDER_INFO]: (state: Istate, payload: any) => {
    state.orderInfo = payload
  },
}

export const store = {
  state,
  getters,
  mutations,
}
